export default __webpack_public_path__ + "48378f95a9d19ea9f9341fe611790f21.png";